module.exports = __webpack_public_path__ + "img/scope-youtube.4149e688.png";